module.exports = __webpack_public_path__ + "static/media/YM19_4.4f39160e.jpg";